export const AuthErrorCodes = {
  NotAuthenticated: 'AUTH_NOT_AUTHENTICATED',
  EmailDuplicate: 'EMAIL_DUPLICATE',
  UsernameDuplicate: 'USERNAME_DUPLICATE',
  UnknownError: 'UNKNOWN_ERROR',
  UserNotFound: 'USER_NOT_FOUND',
  EmailAlreadyConfirmed: 'EMAIL_ALREADY_CONFIRMED',
  DriverNotFound: 'DRIVER_NOT_FOUND',
}
